import { registerColumns } from './columnRegistry';

registerColumns('plan', []);
